interface VideoTestimonialsSectionProps {
  onOpenModal?: () => void;
}

export default function VideoTestimonialsSection({ onOpenModal }: VideoTestimonialsSectionProps) {
  const videos = [
    {
      id: 'zb9YgeKgAKQ',
      title: 'Depoimento 1',
      embedUrl: 'https://www.youtube.com/embed/zb9YgeKgAKQ'
    },
    {
      id: 'jNFwN0xkKnc',
      title: 'Depoimento 2',
      embedUrl: 'https://www.youtube.com/embed/jNFwN0xkKnc'
    },
    {
      id: 'YHR64QQqjdk',
      title: 'Depoimento 3',
      embedUrl: 'https://www.youtube.com/embed/YHR64QQqjdk'
    },
    {
      id: 'f-iBKyG_xDI',
      title: 'Depoimento 4',
      embedUrl: 'https://www.youtube.com/embed/f-iBKyG_xDI'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Veja o que nossos alunos dizem
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Histórias reais de transformação através da comunicação
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto mb-12">
          {videos.map((video) => (
            <div
              key={video.id}
              className="relative bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 hover:scale-[1.02] mx-auto w-full max-w-[280px]"
            >
              <div className="relative pb-[177.78%]">
                <iframe
                  src={video.embedUrl}
                  title={video.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="absolute top-0 left-0 w-full h-full"
                  style={{ border: 'none' }}
                ></iframe>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={onOpenModal}
            className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white font-bold py-4 px-8 rounded-full text-lg transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Quero transformar minha comunicação
          </button>
        </div>
      </div>
    </section>
  );
}
